var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59268 17.6983C8.20216 17.3078 8.20216 16.6746 8.59269 16.2841L12.8803 11.9965L8.59819 7.71431C8.20767 7.32379 8.20767 6.69062 8.5982 6.3001C8.98872 5.90957 9.62188 5.90957 10.0124 6.3001L14.6481 10.9358C15.2339 11.5216 15.2339 12.4713 14.6481 13.0571L10.0069 17.6983C9.61637 18.0888 8.9832 18.0888 8.59268 17.6983Z",
    fill: "#47474B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.18281368024a47e55a956de1da475019.svg";
export { ForwardRef as ReactComponent };